let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bZO0a")).then(() => parcelRequire('duHPY'));